import { Component, OnInit } from '@angular/core';
import { ActivityCard } from '../core/domain/activity-card';
import { ActivityCardFactory } from './activity-card/activity-card-factory';
import { SeoService } from '../core/service/seo.service';
import { ActivityCardComponent } from './activity-card/activity-card.component';
import { TimetableComponent } from './timetable/timetable.component';

@Component({
  selector: 'app-agenda',
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.css'],
  imports: [ActivityCardComponent, TimetableComponent],
})
export class AgendaComponent implements OnInit {
  activityBjjGi: ActivityCard;
  activityBjjNoGi: ActivityCard;
  activityBjjKids: ActivityCard;
  activityBjjWomen: ActivityCard;
  activityBjjDrills: ActivityCard;
  activityBjjSparring: ActivityCard;
  activityOpenMat: ActivityCard;

  constructor(private seoService: SeoService) {
    this.activityBjjGi = ActivityCardFactory.bjjGi();
    this.activityBjjNoGi = ActivityCardFactory.bjjNoGi();
    this.activityBjjKids = ActivityCardFactory.bjjKids();
    this.activityBjjWomen = ActivityCardFactory.bjjWomen();
    this.activityBjjDrills = ActivityCardFactory.bjjDrills();
    this.activityBjjSparring = ActivityCardFactory.bjjSparring();
    this.activityOpenMat = ActivityCardFactory.openMat();
  }

  ngOnInit(): void {
    this.seoService.updateMetaTag(
      'description',
      'Entdecken Sie unsere wöchentlichen Kurse und lernen Sie etwas Neues. ' + 'Hier finden Sie eine Übersicht über alle Kurse und Termine.',
    );
    this.seoService.createLinkForCanonicalURL('/agenda');
  }
}
